import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { Modal } from "react-bootstrap";
import { Input, Label } from "reactstrap";
import "./addlocations.scss";
import Plusicon from "../../../../assets/icon/plusicon";

function AddLocationModel(props) {
  const { inputValue, setInputValue, handleChange, errors, setError, formType, handleAddNews, loading, handleOnClose, deleteDataId, setDeleteDataId } = props;

  const [inputErrors, setInputErrors] = useState({});

  const handleDynamicInputChange = (index, event) => {
    const updatedInputs = [...inputValue?.dynamicInputs];
    updatedInputs[index].deviceId = event.target.value;

    const updatedErrors = { ...inputErrors };
    if (event.target.value.trim() !== "") {
      delete updatedErrors[index];
    }
    setInputErrors(updatedErrors);
    setError({ ...errors, dynamicInputs: "" });
    setInputValue({ ...inputValue, dynamicInputs: updatedInputs });
  };

  const addNewInput = () => {
    // Check for empty inputs
    const newErrors = {};

    inputValue.dynamicInputs.forEach((input, index) => {
      if (input.deviceId.trim() === "") {
        newErrors[index] = "Bitte geben Sie hier die Kamera-ID ein";
      }
    });

    // If there are errors, set them and exit
    if (Object.keys(newErrors).length > 0) {
      setInputErrors(newErrors);
      return;
    }

    // Add a new dynamic input
    setInputValue((prevState) => ({
      ...prevState,
      dynamicInputs: [...prevState.dynamicInputs, { id: Date.now(), deviceId: "" }],
    }));
  };

  const removeInput = (index) => {
    // const updatedInputs = inputValue?.dynamicInputs.filter((_, i) => i !== index);
    // setInputValue({ ...inputValue, dynamicInputs: updatedInputs });
    const deletedAlert = inputValue?.dynamicInputs[index];
    const updatedData = inputValue?.dynamicInputs.filter((_, i) => i !== index);
    setInputValue({ ...inputValue, dynamicInputs: updatedData });
    if (deletedAlert._id) {
      setDeleteDataId((prevIds) => [...prevIds, { deviceId: deletedAlert._id, locationId: inputValue?._id }]);
    }

    // Remove associated error if it exists
    const updatedErrors = { ...inputErrors };
    delete updatedErrors[index];
    setInputErrors(updatedErrors);
  };

  const bindInput = (value) => {
    var regex = new RegExp("^[^0-9]*$");
    var key = String.fromCharCode(!value.charCode ? value.which : value.charCode);
    if (regex.test(key)) {
      value.preventDefault();
      return false;
    }
  };

  return (
    <div className="modal-content new-model-conent-sye" style={{ maxHeight: "600px", overflow: "auto" }}>
      <Modal.Header className="justify-content-start d-flex align-items-center" closeButton>
        <Modal.Title style={{ color: "#FFDF5C" }}>{formType == "add" ? "Standort hinzufügen" : "Standort aktualisieren"} </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: "auto" }}>
        <div class=" pb-3">
          <div>
            <Label className="form-label" for="name">
              Standorte <span className="text-danger">*</span>
            </Label>
            <Input placeholder="Standorte" name="name" value={inputValue?.name} onChange={(event) => handleChange(event, "input")} invalid={errors?.name && "true"} />
            <span className="errors">{errors?.name}</span>
          </div>
        </div>
        <div class=" pb-3">
          <div>
            <Label className="form-label" for="name">
              maximale Parkzeit<span className="text-danger">*</span>
            </Label>
            <div className="maximale-input-main">
              <Input placeholder="maximale Parkzeit" name="maxParkingTime" value={inputValue?.maxParkingTime} onChange={(event) => handleChange(event, "input")} onKeyPress={bindInput} invalid={errors?.maxParkingTime && "true"} />
              <div className="maximale-input-min">
                <p>min</p>
              </div>
            </div>
            <span className="errors">{errors?.maxParkingTime}</span>
          </div>
        </div>
        <div class=" pb-3">
          <div>
            <Label className="form-label" for="name">
              maximale Parklücke<span className="text-danger">*</span>
            </Label>
            <div className="maximale-input-main">
              <Input type="number" placeholder="maximale Parklücke" name="maxParkingSlots" value={inputValue?.maxParkingSlots} onChange={(event) => handleChange(event, "input")} onKeyPress={bindInput} invalid={errors?.maxParkingSlots && "true"} />
            </div>
            <span className="errors">{errors?.maxParkingSlots}</span>
          </div>
        </div>
        <div className="dynamic-inputs">
          <Label className="form-label">
            Geräte-ID-Informationen<span className="text-danger">*</span>
          </Label>
          {inputValue?.dynamicInputs?.map((input, index) => (
            <div key={input.id}>
              <div className="d-flex align-items-center mb-2">
                <Input placeholder={`Gerät ${index + 1}`} value={input.deviceId} onChange={(event) => handleDynamicInputChange(index, event)} invalid={!!inputErrors[index]} />
                <div className="dynamicinputsdeletebutton" onClick={() => removeInput(index)}>
                  <i class="fas fa-trash-alt" style={{ fontSize: "20px" }}></i>
                </div>
              </div>
              {inputErrors[index] && <span className="errors text-danger ml-2">{inputErrors[index]}</span>}
              {!inputErrors[index] && errors?.dynamicInputs && <span className="errors">{errors?.dynamicInputs}</span>}
            </div>
          ))}
          <div className="dynamicinputsplusbutton" onClick={addNewInput}>
            <Plusicon />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="activebutton h-40px" onClick={handleOnClose} style={{ marginRight: "15px" }}>
          Abbrechen
        </Button>
        <Button disabled={loading} className="addbutton" onClick={handleAddNews}>
          <span>{formType == "add" ? " Speichern" : "aktualisieren"}</span>
          {loading && <div class="h-20px spinner-border text-light w-20px ml-2"></div>}
        </Button>
      </Modal.Footer>
    </div>
  );
}

export default AddLocationModel;
